import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { Shell } from "@/components/control-tower/Layout";
import { SmartChat } from "@/components/chat/SmartChat";
import { useInventoryFilter } from "@/lib/inventory-filter";
import { inventoryChatScope } from "@/lib/chat-scope";

export const Route = createFileRoute("/chat")({
  component: AgentPage,
});

// General/portfolio converse Toiminto — same SmartChat shell as hero "Kysy agentilta",
// scoped from ScopeBar / inventory filter. No second Konteksti picker.
function AgentPage() {
  const { buildingId, groupId } = useInventoryFilter();
  const chatScope = useMemo(
    () => inventoryChatScope(buildingId, groupId),
    [buildingId, groupId],
  );

  return (
    <Shell title="Kairos" subtitle="Keskustele kiinteistöjen kanssa">
      <div className="flex flex-col gap-3 h-[calc(100vh-9rem)]">
        <SmartChat
          key={JSON.stringify(chatScope)}
          scope={chatScope}
          buildingId={buildingId ?? undefined}
          className="flex-1 min-h-0"
        />
      </div>
    </Shell>
  );
}
